/** Requerimiento movil alineado a la web (Yup, con su test).
 *
 * Alta: cliente + nombre + tipo + fecha requerida (>= hoy) + descripcion
 * opcional. El codigo es automatico y la fecha de solicitud la fija el
 * servidor; los adjuntos se suben despues de crear, desde el detalle.
 */
import * as yup from 'yup';

function todayIso(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const mobileRequirementSchema = yup.object({
  title: yup
    .string()
    .required('El titulo es obligatorio')
    .trim()
    .min(4, 'El titulo es muy corto')
    .max(200, 'El titulo es muy largo'),
  notes: yup.string().trim().max(2000, 'Las notas son muy largas').default(''),
});

export type MobileRequirementForm = yup.InferType<typeof mobileRequirementSchema>;

export const mobileRequirementCreateSchema = yup.object({
  client_id: yup.string().required('El cliente es obligatorio'),
  name: yup
    .string()
    .required('El nombre es obligatorio')
    .trim()
    .min(2, 'El nombre es muy corto')
    .max(255, 'El nombre es muy largo'),
  type: yup
    .string()
    .oneOf(['standard', 'project'] as const, 'El tipo no es valido')
    .default('standard')
    .required('El tipo es obligatorio'),
  required_date: yup
    .string()
    .required('La fecha requerida es obligatoria')
    .test('no-pasada', 'La fecha no puede ser anterior a hoy', (value) => {
      if (!value) return false;
      return value >= todayIso();
    }),
  description: yup.string().trim().max(5000, 'La descripcion es muy larga').default(''),
});

export type MobileRequirementCreateForm = yup.InferType<typeof mobileRequirementCreateSchema>;

/** Edición móvil: nombre + fecha requerida (>= hoy) + descripción (PUT al detalle). */
export const mobileRequirementEditSchema = yup.object({
  name: yup
    .string()
    .required('El nombre es obligatorio')
    .trim()
    .min(2, 'El nombre es muy corto')
    .max(255, 'El nombre es muy largo'),
  required_date: yup
    .string()
    .required('La fecha requerida es obligatoria')
    .test('no-pasada', 'La fecha no puede ser anterior a hoy', (value) => {
      if (!value) return false;
      return value >= todayIso();
    }),
  description: yup.string().trim().max(5000, 'La descripcion es muy larga').default(''),
});

export type MobileRequirementEditForm = yup.InferType<typeof mobileRequirementEditSchema>;
